<template>
    <button 
      type="button" 
      @click="$emit('cancel')" 
      class="px-4 py-2 my-3 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition duration-300 ease-in-out"
    >
      {{ text }}
    </button>
  </template>
  
  <script lang="ts">
  export default {
    name: 'CancelReturnButton',
    emits: ['cancel'],
    props: {
    text: {
      type: String,
      required: true
    }
  }
  }
  </script>